import type { StateType } from '../lib/types/state-type';
import { createInitialState } from '../lib/types/state-type';
import { singleton } from 'tsyringe';

@singleton()
export class Observer {
  constructor() {}

  private state: StateType = createInitialState();

  private data = new Map<string, unknown>([['publish', this.state]]);

  private subscribers: { [event: string]: Array<(data: unknown) => void> } = {};

  public publish(event: string, data: unknown): void {
    this.data.set(event, data);
    if (!Array.isArray(this.subscribers[event])) {
      return;
    }
    this.subscribers[event].forEach((callback: (data: unknown) => void) => {
      callback(data);
    });
  }

  public subscribe(event: string, callBack: (data: unknown) => void, publishImmediately = true): void {
    if (!Array.isArray(this.subscribers[event])) {
      this.subscribers[event] = [];
    }
    this.subscribers[event].push(callBack);

    if (publishImmediately) {
      callBack(this.data.get(event));
    }
  }

  public unsubscribe(event: string, callback: (data: unknown) => void): void {
    if (!this.subscribers[event]) {
      return;
    }
    this.subscribers[event] = this.subscribers[event].filter((cb: (data: unknown) => void) => {
      if (cb === callback) {
        return false;
      }
      return true;
    });
  }
}
